<template>
    <v-card class="pb-5">
        <v-card-title>
            <span class="text-h5">Return Customer</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('modal-close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-container>
            <div class="mt-5" v-on:keyup.enter="tempReservation?confirm:true">
                <v-row v-if="!tempReservation">
                    <v-col offset-md="1" cols="12" md="10" v-if="notFoundMessage!==''">
                        <h5 class="red--text">{{notFoundMessage}}</h5>
                    </v-col>
                    <form v-on:keydown.enter="searchCustomer" style="width: 100%">
                        <v-col offset-md="1" cols="12" md="10">
                            <v-text-field ref="return_cus_full_name_ref" label="Full Name" v-model="model.full_name" autofocus></v-text-field>
                            <v-text-field label="Date Of Birth (mm/dd/yyyy)" v-model="model.dob" v-mask="'##/##/####'" placeholder="mm/dd/yyyy" ></v-text-field>
                        </v-col>
                        <v-col offset-md="1" cols="12" md="10" style="text-align: right">
                            <v-btn @click="skip">Skip</v-btn>
                            <v-btn class="ml-2" color="primary" @click="searchCustomer">Search</v-btn>
                        </v-col>
                    </form>
                </v-row>
                <v-row v-if="tempReservation">
                    <form v-on:keydown.enter="confirm" style="width: 100%">
                        <v-col cols="12" style="text-align:center">
                            <h4 class="blue--text mb-5">We found you in the system! Please confirm.</h4>
                        </v-col>
                        <v-col offset-md="1" cols="12" md="10">
                            <div>{{ tempReservation.reservation.first_name }} {{ tempReservation.reservation.last_name }}</div>
                            <div>{{ tempReservation.reservation.city }}, {{ tempReservation.reservation.state }} {{ tempReservation.reservation.zip }}</div>
                            <div><strong>Email:</strong> {{tempReservation.reservation.email}}</div>
                            <div class="mb-5"><strong>Mobile phone:</strong>  {{tempReservation.reservation.phone}}</div>
                        </v-col>
                        <v-col offset-md="1" cols="12" md="10">
                            <h6 class="mb-3" v-if="checkedReserveeList.length!=0"><strong>Please select any other member that are with you today</strong></h6>
                            <v-checkbox
                                    class="mt-0"
                                    :hide-details="true"
                                    multiple
                                    :key="'checkbox__package_addon_'+reservee.id"
                                    v-for="reservee in checkedReserveeList"
                                    v-model="reservee_checked"
                                    :label="reservee.full_name"
                                    :value="reservee.id"
                                >

                                </v-checkbox>
                        </v-col>
                        <v-col offset-md="1" cols="12" md="10" style="text-align: right">
                            <v-btn @click="skip">Skip</v-btn>
                            <v-btn ref="confirm-btn" class="ml-2" color="primary"  @click="confirm">Confirm</v-btn>
                        </v-col>
                    </form>
                </v-row>
            </div>
        </v-container>
    </v-card>
</template>

<script>
import axios                 from "axios";
import StepperComponentMixin from "../../mixins/StepperComponentMixin";

export default {
    name  : "DialogReturnCustomer",
    mixins: [StepperComponentMixin],
    data  : () => ({
        model: {
            full_name: '',
            dob      : null
        },
        tempReservation: null,
        notFoundMessage: '',
        response:{
            full_name:'',
        },
        reservee_checked: []
    }),
    methods:{
        async searchCustomer(){
            if(this.model.full_name!=="" || this.model.dob!==null) {
                const searchResponse = await axios.get('/reservations/search_renter', {
                    params: this.model
                }).catch(error => {
                    return error.response;
                });

                if (searchResponse.data && searchResponse.data.success && searchResponse.data.exists && searchResponse.data.redirect) {
                    const response = await axios.get('/reservations/vue/load_reservation', {
                        headers: {
                            'Content-Type': 'application/json'
                        }} );
                    this.tempReservation = response.data.data;
                    this.$store.commit('set_return_customer_full_name', this.model.full_name);
                    this.$store.commit('set_return_customer_dob', this.model.dob);
                    this.notFoundMessage = '';

                    this.$nextTick(() => {
                        this.$refs['confirm-btn'].$el.focus();
                    })

                } else {
                    this.notFoundMessage = searchResponse.data.message;
                }
            }else{
                this.notFoundMessage = "Name and DOB are required";
            }
        },
        async skip(){
            await axios.post('/reservations/vue/reset_reservation');
            this.$emit('modal-close');
        },
        async confirm(){
            this.tempReservation.reservees = this.tempReservation.reservees.filter((element) => {  
                return ( (element.full_name.toLowerCase() == this.model.full_name.toLowerCase() && (element.dob == this.model.dob)) || (this.reservee_checked.includes(element.id)));
            });

            this.tempReservation.reservation.date_pickup=null;
            this.tempReservation.reservation.date_return=null;
            this.tempReservation.reservation.is_international_customer = false;
            this.tempReservation.reservation.reservees_number =  this.tempReservation.reservees.length || 1;
            this.tempReservation.reservation.email_confirmation = this.tempReservation.reservation.email;
            this.tempReservation.reservation.is_delivery = this.$store.state.model.reservation.is_delivery;
            for(let key in this.tempReservation.reservation){
                if (!this.$store.state.model.reservation.is_seasonal || (this.$store.state.model.reservation.is_seasonal && (key !== 'date_pickup' && key !== 'date_return')) || (parseInt(this.$store.state.resources.config.is_international_canadian) && (key !== 'state' && key !== 'zip'))) {
                    this.$store.commit('set_model_value',{
                        path:'model.reservation.'+key,
                        value:this.tempReservation.reservation[key]
                    })
                }
            }
            if(parseInt(this.$store.state.resources.config.is_international_canadian)){
                this.$store.commit('set_model_value',{
                    path:'model.reservation.country',
                    value:'CA'
                })
                this.$store.commit('set_model_value',{
                    path:'model.reservation.state',
                    value:''
                })
                this.$store.commit('set_model_value',{
                    path:'model.reservation.zip',
                    value:''
                })
            }
            if(parseInt(this.$store.state.resources.config.is_international_canadian) && this.tempReservation.reservation["postal_code"]=="0"){
                this.$store.commit('set_model_value',{
                    path:'model.reservation.postal_code',
                    value:''
                })
            }
            if(parseInt(this.$store.state.resources.config.is_international_canadian) && this.tempReservation.reservation["province"]=="0"){
                this.$store.commit('set_model_value',{
                    path:'model.reservation.province',
                    value:''
                })
            }
            if(!parseInt(this.$store.state.resources.config.is_international_canadian) && this.tempReservation.reservation["state"]=="0"){
                this.$store.commit('set_model_value',{
                    path:'model.reservation.state',
                    value:''
                })
            }
            if(!parseInt(this.$store.state.resources.config.is_international_canadian) && this.tempReservation.reservation["zip"]=="0"){
                this.$store.commit('set_model_value',{
                    path:'model.reservation.zip',
                    value:''
                })
            }
            // if ((this.states.filter(e => e.abbreviation === this.tempReservation.reservation["state"]).length) == 0) {
            //     this.$store.commit('set_model_value',{
            //         path:'model.reservation.state',
            //         value:''
            //     })
            // }
          
            this.$store.commit('set_model_value',{path:'model.reservees',value:this.tempReservation.reservees})
            this.$emit('modal-close');
        }
    },
    computed  : {
        is_international_canadian(){
            return parseInt(this.$store.state.resources.config.is_international_canadian);
        },
        states() {
            return this.is_international_canadian?this.$store.state.resources.canadian_states:this.$store.state.resources.states;
        },
        checkedReserveeList() {
            return this.tempReservation.reservees.filter((element) => {  
                return ( !(element.full_name.toLowerCase() == this.model.full_name.toLowerCase() && element.dob == this.model.dob));
            });
        }
    },

    watch: {
        '$store.state.focusInput': function(inputRef) {
            this.$refs.return_cus_full_name_ref.focus();
        },
    },

    mounted() {
        if (!document.activeElement) {
            this.$refs.return_cus_full_name_ref.focus();
            this.$refs.return_cus_full_name_ref.$el.focus();
        }
    },

}
</script>

<style scoped>

</style>
